import { useState, useEffect, useMemo } from "react";
import { useCacheContext, CacheKeys } from "../Cache";
import { ENVIRONMENTS_FILTERS } from "../../helpers/EnvironmentsFilters";
import { IEnvironment, FilterFnType } from "../../interfaces";

interface State {
  envs: IEnvironment[];
}

const DEFAULT_STATE: State = {
  envs: [],
};

const DEFAULT_FILTER = ENVIRONMENTS_FILTERS?.numberFilter("priority");

export const useEnvironments = () => {
  const [state, setState] = useState<State>(DEFAULT_STATE);
  const { getFromCache } = useCacheContext();

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      envs: getFromCache(CacheKeys.environments)?.sort(DEFAULT_FILTER),
    }));
  }, [getFromCache]);

  const onFilterChange = (newFilter: FilterFnType) => {
    setState((prevState) => ({
      ...prevState,
      envs: prevState?.envs?.sort(newFilter),
    }));
  };

  const headers = useMemo(
    () => [
      { label: "#" },
      {
        label: "Country",
        onClick: () =>
          onFilterChange(ENVIRONMENTS_FILTERS?.stringFilter("name")),
      },
      { label: "UAT" },
      {
        label: "Created",
        onClick: () =>
          onFilterChange(ENVIRONMENTS_FILTERS?.dateFilter("uatDate")),
      },
      { label: "Version" },
      { label: "PRD" },
      {
        label: "Created",
        onClick: () =>
          onFilterChange(ENVIRONMENTS_FILTERS?.dateFilter("prodDate")),
      },
      { label: "Version" },
      {
        label: "Administration",
        onClick: () =>
          onFilterChange(ENVIRONMENTS_FILTERS?.stringFilter("administration")),
      },
      {
        label: "RM",
        onClick: () => onFilterChange(ENVIRONMENTS_FILTERS?.stringFilter("rm")),
      },
      {
        label: "Priority",
        onClick: () =>
          onFilterChange(ENVIRONMENTS_FILTERS?.numberFilter("priority")),
      },
      {
        label: "Additional domains",
      },
    ],
    []
  );

  return { state, headers } as const;
};

export const useInternalEnvironments = () => {
  const [state, setState] = useState<State>(DEFAULT_STATE);
  const { getFromCache } = useCacheContext();

  useEffect(() => {
    setState((prevState) => ({
      ...prevState,
      envs: getFromCache(CacheKeys.internalEnvironments)?.sort(DEFAULT_FILTER),
    }));
  }, [getFromCache]);

  const onFilterChange = (newFilter: FilterFnType) => {
    setState((prevState) => ({
      ...prevState,
      envs: prevState?.envs?.sort(newFilter),
    }));
  };

  const headers = useMemo(
    () => [
      { label: "#" },
      {
        label: "Country",
        onClick: () =>
          onFilterChange(ENVIRONMENTS_FILTERS?.stringFilter("name")),
      },
      { label: "Url" },
      { label: "Version" },
    ],
    []
  );

  return { state, headers } as const;
};
